import React from "react";
import DynamicUniversityPage from "../../../custom-components/DynamicUniversityPage";
import { jisUniversityJson } from "./JISUniversityJson";
import DynamicWhyChooseThisUniversitiesPage from "../../../custom-components/DynamicWhyChooseThisUniversityPage";
import UniversityKnowMore from "src/CountryPages/University/UniversityKnowMore";
import Location from "../../../custom-components/Location";
import DynamicUniversityDetails from "../../../custom-components/DynamicUniversityDetails";
import DynamicNationalitySelection from "../../../custom-components/DynamicNationalitySelection";

const JISUniversity = ({ data }) => {
  const { heading, backgroundImage, content } = jisUniversityJson.BannerData;

  return (
    <>
      <DynamicUniversityPage
        heading={heading}
        backgroundImage={backgroundImage}
        content={content}
      />
      <DynamicUniversityDetails data={jisUniversityJson.universityDetails} />
      <DynamicWhyChooseThisUniversitiesPage
        rankingsData={jisUniversityJson?.WhyChooseThisUniversityPage}
      />
       <DynamicNationalitySelection data={jisUniversityJson} />
      <Location
        header={jisUniversityJson?.Location?.header}
        image={jisUniversityJson?.Location?.image}
        content={jisUniversityJson?.Location?.content || "No content available"}
      />
      <UniversityKnowMore data={jisUniversityJson?.KnowMore} />
    </>
  );
};

export default JISUniversity;
